module.exports = __webpack_public_path__ + "img/Estrellita-Non-select.0fdb7772.svg";